import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import NavPills from 'components/NavPills/NavPills.jsx';
import pillsStyle from 'assets/jss/material-kit-react/views/componentsSections/pillsStyle.jsx';
import HourlyService from './HourlyService';
import ServicePackage from './ServicePackage';
import { FormattedMessage, injectIntl } from 'react-intl';
import { compose } from 'redux';

class ProfileService extends React.Component {
    render() {
        const { classes, data, userData } = this.props;
        const { formatMessage } = this.props.intl;
        return (
            <div id="navigation-pills">
                <div className={classes.title}>
                    <p>
                        <FormattedMessage
                            id="service.description"
                            defaultMessage="You can book on Hourly basis or book package"
                        />
                    </p>{' '}
                </div>{' '}
                <GridContainer>
                    <GridItem
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        className="detail-tabs-verticals"
                    >
                        <NavPills
                            color="primary"
                            tabs={[
                                {
                                    tabButton: formatMessage({
                                        id: 'service.hourly'
                                    }),

                                    tabContent: (
                                        <span>
                                            <HourlyService
                                                data={data}
                                                clickBookNow={serviceId =>
                                                    this.props.clickBookNow(
                                                        serviceId,
                                                        true
                                                    )
                                                }
                                                userData={userData}
                                            />{' '}
                                        </span>
                                    )
                                },
                                {
                                    tabButton: formatMessage({
                                        id: 'service.packages'
                                    }),

                                    tabContent: (
                                        <span>
                                            <ServicePackage
                                                data={data.packages}
                                                clickBookNow={item =>
                                                    this.props.clickBookNow(
                                                        item,
                                                        false
                                                    )
                                                }
                                                userData={userData}
                                            />
                                        </span>
                                    )
                                }
                            ]}
                        />{' '}
                    </GridItem>{' '}
                </GridContainer>{' '}
            </div>
        );
    }
}
const composedComponent = compose(withStyles(pillsStyle));
export default composedComponent(injectIntl(ProfileService));



// WEBPACK FOOTER //
// ./src/components/Providers/ProfileService.js